
import axios from "axios";
import { ErroMsg, cleanJsonString } from "../../frontend/contents/VariaveisGlobais";

async function ConsultaTotvsEmpresa( cConsulta, cTabelas, cEmpresa ){
    const URLRest = window._env_?.REACT_APP_URL_REST + "CONSULTAEMPRESA";
    const Token = window._env_?.REACT_APP_TOKEN_REST;
    const EmpFilLogado = cEmpresa || localStorage.getItem('empresaFilial');
    const EmpresaParam = EmpFilLogado.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA);
    const FilialParam = EmpFilLogado.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL);

    const empresasAtivas = JSON.parse(localStorage.getItem('empresasOptions'))
    const empFormat = cEmpresa ? (cEmpresa.includes('-') ? cEmpresa : `${cEmpresa.slice(0, 2)}-${cEmpresa.slice(2)}`) : '';
    const empresas = empFormat || empresasAtivas.map( (empresa) => empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) ).join(';');

    const config = JSON.stringify( { consulta: cConsulta, tabelas: cTabelas, empresa: EmpresaParam, filial: FilialParam, empresas: empresas, ts: new Date().getTime() })

    // useEffect(() => {
        var lista = await axios.post( URLRest, config, {
            headers: {
                "tenantId": EmpresaParam + ',' + FilialParam,
                "Content-Type": "application/json",
                'Authorization': `Basic ${Token}`,
                "Accept" : "*/*",
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
            }})
            .then((response) => {
                let responseData = response.data
                
                if (typeof responseData == 'string'){
                    responseData = JSON.parse(cleanJsonString(responseData))
                }
                
                return responseData;
            })
            .catch((err) => {
                ErroMsg('Falha ao Processar Consulta!')
                return {error: "01", description:"Falha ao Processar Consulta!" + err, data: []};
            });
    // }, []);

    return lista;
}

async function ConsultaTotvsEmpresaIndividual( cConsulta, cTabelas, cEmpresa ){
    const URLRest = window._env_?.REACT_APP_URL_REST + "CONSULTAEMPRESAINDIVIDUAL";
    const Token = window._env_?.REACT_APP_TOKEN_REST;
    const EmpFilLogado = localStorage.getItem('empresaFilial');
    const EmpresaParam = EmpFilLogado.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA);
    const FilialParam = EmpFilLogado.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL);

    const empresasAtivas = JSON.parse(localStorage.getItem('empresasOptions'))
    const empFormat = ( cEmpresa ? cEmpresa : '' );
    const empresas = empFormat || empresasAtivas.map( (empresa) => empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) ).join(';');

    const config = JSON.stringify( { consulta: cConsulta, tabelas: cTabelas, empresa: EmpresaParam, filial: FilialParam, empresas: empresas, ts: new Date().getTime() })

    // useEffect(() => {
        var lista = await axios.post(URLRest, config, {
            headers: {
                "tenantId": EmpresaParam + ',' + FilialParam,
                "Content-Type": "application/json",
                'Authorization': `Basic ${Token}`,
                "Accept" : "*/*",
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
            }})
            .then((response) => {
                let responseData = response.data
                
                if (typeof responseData == 'string'){
                    responseData = JSON.parse(cleanJsonString(responseData))
                }
                
                return responseData;
            })
            .catch((err) => {
                ErroMsg('Falha ao Processar Consulta!')
                return {error: "01", description:"Falha ao Processar Consulta!" + err, data: []};
            });
    // }, []);

    return lista;
}

export { ConsultaTotvsEmpresa, ConsultaTotvsEmpresaIndividual }